import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-universal-similarities-modal',
  templateUrl: './universal-similarities-modal.component.html',
  styleUrls: ['./universal-similarities-modal.component.css']
})
export class UniversalSimilaritiesModalComponent {
  public databaseTables: any = [{ name: 'table 1' }, { name: 'table 2' }];
  public auditTypes: any = [{ name: '(I)nsert' }, { name: '(U)pdate' }, { name: '(D)elete' }];
  public isShowModal: boolean = true;

  public selectedColumns: any[] = [];
  public selectedCreatedByColumn: any = null;
  public selectedUpdatedByColumn: any = null;
  public userValueToSearchFor: string = '';

  @Input() columns: any = [];
  @Output() dialogCloseEmitter = new EventEmitter<boolean>();
  @Output() beginSimilaritiesSearch = new EventEmitter<any>();

  constructor() {

  }

  dialogClose() {
    this.dialogClosedEmitter();
  }

  dialogClosedEmitter() {
    this.dialogCloseEmitter.emit(false);
  }

  startSearch() {
    this.dialogCloseEmitter.emit(false);
    const a: any = {
      ExcludeColumns: this.getExcludedColumns().join(', ')
    };

    console.log(a);

    this.beginSimilaritiesSearch.emit(a);
  }

  private getExcludedColumns(): string[] {
    return this.selectedColumns.map(x => {
      return x.name;
      // Assuming the format is always "(X)rest", where `X` is the character we need
      //return x.name.substring(1, 2); // This gets the character between the parentheses
    });
  }

  public resetSearch() {
    this.userValueToSearchFor = '';
    this.selectedCreatedByColumn = null;
    this.selectedUpdatedByColumn = null;
    this.userValueToSearchFor = '';
    this.selectedColumns = [];
  }
}
